import React, { useState, useEffect } from "react";
import styles from "./index.module.scss";
import { Button, DatePicker, Input, Select } from "antd";
import { SvgIcons } from "../../assets/svgIcons";
import { fetch_doctors_list } from "../../actions/ClinicAdminAction";
import { useDispatch, useSelector } from "react-redux";
import ResetFilterButton from "../InterbranchAdminComponents/ResetFilterButton/ResetFilterButton";
import ClearIcon from "@mui/icons-material/Clear";
import { ResetIcon } from "../../assets/Logos/Icons";
import CustomPhoneInputV2 from "../CustomPhoneInputV2/CustomPhoneInputV2";
const { RangePicker } = DatePicker;

const AdminAppointmentFilters = ({
  onFilterSubmit,
  onDownloadRequest,
  onDoctorSelect,
  onAppointmentDateChange,
  onAppointmentStatusChange,
  onDateRangeChange,
  selectedRange,
  setSelectedRange,
  resetFilterAction,
  doctorNames,
  setAppointmentDateSearch,
  appointmentDateSearch,
  resetFilterActionDate,
  appointmentStatus,
  setAppointmentStatus,
  doctorSearch,
  selectedDoctor,
  downloaable,
  // mobileNumber,
  patientEmail,
}) => {
  const [formData, setFormData] = useState({
    datePreset: "TODAY",
    fromDate: "",
    toDate: "",
    filterType: "",
  });
  const dispatch = useDispatch();
  console.log("setAppointmentDateSearch", appointmentDateSearch);
  const [showDateRangePicker, setShowDateRangePicker] = useState(false);
  const handleOnChange = ({ name, value }) => {
    if (name === "filterType") {
      // Reset data when filterType changes
      resetFilterAction();
    }

    setFormData({ ...formData, [name]: value });
    console.log("data", name, value);

    if (name === "datePreset") {
      setShowDateRangePicker(value === "CUSTOM");
      setSelectedRange(null);
    }
  };
  const handleDateRangeChange = ({ name, value }) => {
    setFormData({
      ...formData,
      customDateRange: { ...formData.customDateRange, [name]: value },
    });
  };

  const handleResetFilter = () => {
    console.log("Resetting filter...");
    setFormData({
      ...formData,
      datePreset: "TODAY",
      filterType: "",
    });
  };

  const handleResetFilters = () => {
    if (appointmentDateSearch !== null) {
      setAppointmentDateSearch(null);
    }
    if (appointmentStatus !== null) {
      setAppointmentStatus(null);
    }
  };

  const handleDoctorSelect = (doctorId) => {
    if (onDoctorSelect) {
      onDoctorSelect(doctorId);
    }
  };

  const handleDownload = () => {
    switch (formData.datePreset) {
      case "TODAY":
        return { name: "TODAY" };
      case "CUSTOM":
        return {
          name: "CUSTOM",
          value: {
            fromDate: formData.fromDate,
            toDate: formData.toDate,
          },
        };
      default:
        break;
    }
  };
  console.log("formData", formData);

  const handleSearch = () => {
    switch (formData.filterType) {
      case "BY_PATIENT":
        return { name: "BY_PATIENT", value: formData.patientName };
      case "BY_NUMBER":
        return { name: "BY_NUMBER", value: formData.patientNumber };
      case "BY_EMAIL":
        return { name: "BY_EMAIL", value: formData.patientEmail };
      default:
        break;
    }
  };

  const handleSearchSubmit = () => {
    const _data = handleSearch();
    if (onFilterSubmit) {
      onFilterSubmit({
        filterParams: _data,
        SearchType: formData.filterType,
      });
      console.log("data", _data);
    }
  };

  const handleDownloadSubmit = () => {
    const _data = handleDownload();
    if (onDownloadRequest) {
      onDownloadRequest(_data);
    }
  };

  console.log("formData.filterType", formData.filterType);

  return (
    <div className={styles.container}>
      {/* <div className={styles.section}>
        <h5>View/Download Reports</h5>
        <div
          className={styles.itemWrap}
          style={{ maxWidth: "400px", position: "relative" }}
        >
          <div className={styles.itemContainer}>
            <Select
              // allowClear
              placeholder="Select Date Preset"
              name="datePreset"
              onChange={(e) => {
                handleOnChange({ name: "datePreset", value: e });
              }}
              width={120}
              value={formData.datePreset}
              defaultValue={"TODAY"}
              options={[
                { value: "TODAY", label: "Today" },
                { value: "CUSTOM", label: "Custom" },
              ]}
            />
          </div>
          {formData.datePreset === "CUSTOM" ? (
            <div style={{ position: "absolute", marginLeft: "90px" }}>
              <ClearIcon
                onClick={() => {
                  resetFilterAction();
                  setShowDateRangePicker(false);
                  handleResetFilter();
                }}
                style={{ cursor: "pointer", width: "60px", height: "11px" }}
              />
            </div>
          ) : null}
        </div>
        {formData.datePreset === "CUSTOM" && showDateRangePicker ? (
          <DateRangePicker
            onSearch={handleDownloadSubmit}
            onChange={handleDateRangeChange}
            onDateRangeChange={onDateRangeChange}
            formData={formData}
            resetFilterAction={resetFilterAction}
            setShowDateRangePicker={setShowDateRangePicker}
            selectedRange={selectedRange}
            handleResetFilter={handleResetFilter}
            downloaable={downloaable}
          />
        ) : null}
      </div> */}
      <div className={`${styles.section} ${styles.filterSection}`}>
        <h5>Search/Filter Results</h5>

        <div className={styles.itemWrap}>
          <div className={styles.itemContainer}>
            <Select
              width={120}
              onChange={(e) => {
                handleOnChange({ name: "filterType", value: e });
              }}
              placeholder="Please select"
              value={formData.filterType != "" ? formData.filterType : null}
              options={[
                { value: "BY_PATIENT", label: "By Patient name" },
                { value: "BY_NUMBER", label: "By Mobile number" },
                { value: "BY_EMAIL", label: "By Email ID" },
              ]}
            />
          </div>
          {
            {
              BY_PATIENT: (
                <PatientFilter
                  onChange={handleOnChange}
                  resetFilterAction={resetFilterAction}
                />
              ),
              BY_NUMBER: (
                <NumberFilter
                  onChange={handleOnChange}
                  resetFilterAction={resetFilterAction}
                  // mobileNumber={mobileNumber}
                />
              ),
              BY_EMAIL: (
                <EmailFilter
                  onChange={handleOnChange}
                  resetFilterAction={resetFilterAction}
                  patientEmail={patientEmail}
                />
              ),
            }[formData.filterType]
          }
          <button onClick={handleSearchSubmit} className={styles.searchBtn}>
            <SvgIcons.SearchIcon />
          </button>
          {formData.filterType && (
            <div className={styles.searchBtn}>
              <ResetFilterButton
                visibility={formData.filterType}
                handleReset={() => {
                  resetFilterAction();
                  handleResetFilter();
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminAppointmentFilters;

const NumberFilter = ({ onChange, resetFilterAction }) => {
  const [number, setNumber] = useState("");

  const handleNumberChange = (value, formattedValue, data, event) => {
    const { dialCode, number } = data;
    const formattedMobileNumber = `%2B${dialCode} ${number}`;
    setNumber(number); 
    console.log("mobileNumber", formattedMobileNumber); 
    onChange({ name: "patientNumber", value: formattedMobileNumber });
  };

  return (
    <div className={styles.itemContainer} style={{ marginRight: "30px" }}>
      <CustomPhoneInputV2
        placeholder="By Number"
        name="patientNumber"
        value={number}
        onChange={handleNumberChange}
        css={{
          width: "120%",
          height: "42px",
          backgroundColor: "white",
          borderRadius: "6px",
          fontSize: "14px",
        }}
      />
    </div>
  );
};

const PatientFilter = ({ onChange, resetFilterAction }) => {
  return (
    <div className={styles.itemContainer}>
      <Input
        onChange={(e) => {
          onChange({ name: "patientName", value: e.target.value });
        }}
        maxLength={20}
        placeholder="By patient name"
        onKeyPress={(e) => {
          const englishRegex = /^[a-zA-Z\s]*$/;
          if (!englishRegex.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
            e.preventDefault();
          }
        }}
        onPaste={(e) => {
          const pastedData = e.clipboardData.getData('text/plain');
          const englishRegex = /^[a-zA-Z\s]*$/;
          if (!englishRegex.test(pastedData)) {
            e.preventDefault();
          }
        }}
      />
    </div>
  );
};

const EmailFilter = ({ onChange, resetFilterAction, patientEmail }) => {
  const [email, setEmail] = useState(patientEmail || "");
  const [errorMessage, setErrorMessage] = useState("");

  const handleEmailChange = (e) => {
    const inputValue = e.target.value;
    const emailRegex = /^[a-zA-Z][a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    setEmail(inputValue);
    onChange({ name: 'patientEmail', value: inputValue });

    if (!emailRegex.test(inputValue) && inputValue !== '') {
      setErrorMessage('Please enter a valid email id');
    } else {
      setErrorMessage('');
    }
  };

  return (
    <>
      <div className={styles.itemContainer} style={{ marginRight: "100px" }}>
        <Input
          value={email}
          onChange={handleEmailChange}
          placeholder="By Email ID"
          style={{ width: "400px", display: "flex" }}
          maxLength={30}
          onKeyPress={(e) => {
            const englishRegex = /^[a-zA-Z0-9@\.\s]*$/;
            if (!englishRegex.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
              e.preventDefault();
            }
          }}
          onPaste={(e) => {
            const pastedData = e.clipboardData.getData('text/plain');
            const englishRegex = /^[a-zA-Z0-9@\.\s]*$/;
            if (!englishRegex.test(pastedData)) {
              e.preventDefault();
            }
          }}
        />
      </div>
      <div style={{ position: "relative" }}>
        {errorMessage && (
          <p
            style={{
              color: "red",
              marginLeft: "-300px",
              marginTop: "25px",
              position: "absolute",
              fontSize:"12px"
            }}
          >
            {errorMessage}
          </p>
        )}
      </div>
    </>
  );
};
